// extracted by mini-css-extract-plugin
export default {"container":"InputError--container--20b8ff"};